import { mediaQuery, MOBILE_BOTTOM_NAV } from 'constants/ui';

const LOAN_EDITOR_CHAT_DRAWER_Z_INDEX = 1_301;

const MOBILE_FAB_SIZE = 48;

const MOBILE_FAB_OFFSET = 16;

export const edgeTriggerStyles = isHidden => ({
  position: 'fixed',
  right: 0,
  top: '50%',
  transform: 'translateY(-50%)',
  zIndex: 1200,
  width: '36px',
  height: '56px',
  minWidth: 0,
  padding: 0,
  display: isHidden ? 'none' : 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '8px 0 0 8px',
  backgroundColor: ({ palette }) => palette.primary.main,
  color: ({ palette }) => palette.primary.contrastText,
  boxShadow: '-2px 2px 12px rgba(0, 0, 0, 0.15)',
  transition: 'background-color 150ms ease',
  '&:hover': {
    backgroundColor: ({ palette }) => palette.primary.dark,
  },
  '&:focus-visible': {
    outline: '2px solid',
    outlineColor: ({ palette }) => palette.primary.light,
    outlineOffset: '2px',
  },

  // On mobile the mid-right edge-tab is clipped and collides with content, so render a circular FAB
  // in the bottom-LEFT corner, lifted above the floating bottom-nav (mirrors AiAssistantLauncher,
  // which owns the bottom-right). env() is 0 off-device.
  [mediaQuery.mobile]: {
    top: 'auto',
    right: 'auto',
    left: `${MOBILE_FAB_OFFSET}px`,
    bottom: `calc(${
      MOBILE_BOTTOM_NAV.GAP + MOBILE_BOTTOM_NAV.HEIGHT + MOBILE_FAB_OFFSET
    }px + env(safe-area-inset-bottom, 0px))`,
    transform: 'none',
    width: `${MOBILE_FAB_SIZE}px`,
    height: `${MOBILE_FAB_SIZE}px`,
    borderRadius: '50%',
    boxShadow: ({ palette }) => palette.shadow.m,
  },
});

export const edgeTriggerIconStyles = {
  fontSize: '20px',

  [mediaQuery.mobile]: {
    fontSize: '24px',
  },
};

export const triggerBadgeStyles = {
  position: 'absolute',
  top: '-6px',
  left: '-6px',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  minWidth: '18px',
  height: '18px',
  padding: '0 6px',
  borderRadius: '9px',
  backgroundColor: ({ palette }) => palette.error.main,
  pointerEvents: 'none',

  [mediaQuery.mobile]: {
    top: '-2px',
    left: 'auto',
    right: '-2px',
  },
};

export const triggerBadgeLabelStyles = {
  color: ({ palette }) => palette.error.contrastText,
  lineHeight: 1,
};

export const drawerPaperStyles = width => ({
  width: `${width}px`,
  maxWidth: '100vw',
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
  boxShadow: '-4px 0 18px rgba(0,0,0,0.08)',
  zIndex: LOAN_EDITOR_CHAT_DRAWER_Z_INDEX,

  [mediaQuery.mobile]: {
    width: '100vw',
  },
});

export const drawerRootStyles = {
  zIndex: LOAN_EDITOR_CHAT_DRAWER_Z_INDEX,
};

export const drawerHeaderStyles = {
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
  padding: '12px 16px',
  borderBottom: '1px solid',
  borderColor: 'divider',
  gap: '8px',
  backgroundColor: ({ palette }) => palette.background.default,
};

export const titleGroupStyles = {
  flex: 1,
  minWidth: 0,
  display: 'flex',
  flexDirection: 'column',
  gap: '2px',
};

export const titleStyles = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};

export const subtitleRowStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '6px',
  color: ({ palette }) => palette.text.secondary,
};

export const loanBadgeStyles = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: '4px',
  padding: '2px 8px',
  borderRadius: '4px',
  backgroundColor: ({ palette }) => palette.action.hover,
  color: ({ palette }) => palette.text.secondary,
};

export const headerActionsStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
};

export const channelSwitcherRowStyles = {
  display: 'flex',
  padding: '8px 16px',
  borderBottom: '1px solid',
  borderColor: 'divider',
  backgroundColor: ({ palette }) => palette.background.default,
};

export const bodyStyles = {
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  minHeight: 0,
};

export const getChannelPanelStyles = isActive => ({
  flex: 1,
  minHeight: 0,
  display: isActive ? 'flex' : 'none',
  flexDirection: 'column',
});

export const loadingStyles = {
  flex: 1,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

export const errorStyles = {
  padding: '24px 16px',
  color: ({ palette }) => palette.text.secondary,
  textAlign: 'center',
};

export const resizeHandleStyles = {
  position: 'absolute',
  top: 0,
  left: 0,
  height: '100%',
  width: '4px',
  cursor: 'col-resize',
  backgroundColor: 'transparent',
  '&:hover, &:active': {
    backgroundColor: ({ palette }) => palette.background.disabled,
  },

  [mediaQuery.mobile]: {
    display: 'none',
  },
};
